import {
	GET_CLIO_INTEGRATION_SETTINGS_SUCCESS,
	GET_CLIO_INTEGRATION_SETTINGS_FAILURE,
	GET_TENANT_FEATURES_USAGE_AND_FEATURES_SUCCESS,
	GET_FIRM_INFO_SUCCESS,
	UPDATE_FIRM_INFO_FIELD_SUCCESS,
} from "../actions/types";

//
const initialState = {
	ewsUrl: null,
	loading: true,
	tenantFeaturesLoading: true,
	integrationSettingsLoading: true,
	versionControlSettingsLoading: true,
	sharePasswordSettingsLoading: true,
	tenantFeatures: {},
	firmInfo: {},
	firmInfoLoading: true,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case "GET_EWS_URL_SUCCESS":
			var ewsUrl = action.payload;
			return {
				...state,
				loading: false,
				ewsUrl,
			};
		case "SET_EWS_URL_SUCCESS":
			return {
				...state,
				loading: true,
			};
		case "GET_INTEGRATION_SETTINGS_SUCCESS":
			return {
				...state,
				integrationSettingsLoading: false,
				tenantFeatures: { ...state.tenantFeatures, ...action.payload },
			};
		case "SET_INTEGRATION_SETTINGS_REQUEST": {
			return {
				...state,
				integrationSettingsLoading: true,
			};
		}
		case "SET_INTEGRATION_SETTINGS_SUCCESS":
			return {
				...state,
				integrationSettingsLoading: false,
				tenantFeatures: {
					...state.tenantFeatures,
					[action.payload.featureCode]: action.payload.status,
				},
			};
		case "SET_INTEGRATION_SETTINGS_FAILURE":
			return {
				...state,
				integrationSettingsLoading: false,
			};
		case "GET_VERSION_CONTROL_SETTINGS_SUCCESS":
			return {
				...state,
				versionControlSettingsLoading: false,
				tenantFeatures: { ...state.tenantFeatures, ...action.payload },
			};
		case "SET_VERSION_CONTROL_SETTINGS_REQUEST":
			return {
				...state,
				versionControlSettingsLoading: true,
			};
		case "SET_VERSION_CONTROL_SETTINGS_SUCCESS":
			return {
				...state,
				versionControlSettingsLoading: false,
				tenantFeatures: {
					...state.tenantFeatures,
					manualVersioning: action.payload.status,
				},
			};
		case "SET_VERSION_CONTROL_SETTINGS_FAILURE":
			return {
				...state,
				versionControlSettingsLoading: false,
			};
		case "GET_SHARE_PASSWORD_SETTINGS_SUCCESS":
			return {
				...state,
				sharePasswordSettingsLoading: false,
				tenantFeatures: { ...state.tenantFeatures, ...action.payload },
			};
		case "SET_SHARE_PASSWORD_SETTINGS_REQUEST":
			return {
				...state,
				sharePasswordSettingsLoading: true,
			};
		case "SET_SHARE_PASSWORD_SETTINGS_SUCCESS":
			return {
				...state,
				sharePasswordSettingsLoading: false,
				tenantFeatures: {
					...state.tenantFeatures,
					externalShareIsPasswordProtected: action.payload.status,
				},
			};
		case "SET_SHARE_PASSWORD_SETTINGS_FAILURE":
			return {
				...state,
				sharePasswordSettingsLoading: false,
			};
		case GET_CLIO_INTEGRATION_SETTINGS_SUCCESS:
			return {
				...state,
				loading: false,
				clioIntegrationSettingStatus: action.payload,
			};
		case GET_CLIO_INTEGRATION_SETTINGS_FAILURE:
			return {
				...state,
				loading: false,
				clioIntegrationSettingStatus: 0,
			};
		case GET_TENANT_FEATURES_USAGE_AND_FEATURES_SUCCESS:
			return {
				...state,
				tenantFeaturesLoading: false,
				...action.payload,
			};
		case GET_FIRM_INFO_SUCCESS:
			return {
				...state,
				firmInfoLoading: false,
				firmInfo: action.payload,
			};
		case UPDATE_FIRM_INFO_FIELD_SUCCESS:
			return {
				...state,
				firmInfo: {
					...state.firmInfo,
					[action.payload.fieldName]: action.payload.value,
				},
			};
		default:
			return state;
	}
}
